var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrame1171277063(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 40,
    viewBox: "0 0 39 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.300293,
    width: 38,
    height: 40,
    rx: 12,
    fill: "#E0E0E0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3375_19291)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1003 19.7941C15.9948 18.7814 18.398 14.3674 19.4462 10L19.9555 10.5155C20.7652 14.9453 24.466 18.564 28.2612 19.7941C28.2612 19.7941 28.2808 19.8721 28.3003 19.95C24.1087 20.9071 20.8231 24.6401 19.9555 29.3846L19.4462 29.0728C18.274 24.9291 15.9177 20.6657 12.1003 19.7941Z",
    fill: "url(#paint0_linear_3375_19291)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1003 19.7941C15.9948 18.7814 18.398 14.3674 19.4462 10L19.9555 10.5155C20.7652 14.9453 24.466 18.564 28.2612 19.7941C28.2612 19.7941 28.2808 19.8721 28.3003 19.95C24.1087 20.9071 20.8231 24.6401 19.9555 29.3846L19.4462 29.0728C18.274 24.9291 15.9177 20.6657 12.1003 19.7941Z",
    fill: "url(#paint1_linear_3375_19291)",
    fillOpacity: 0.29
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6323 19.9994C15.4839 19.1425 18.5035 14.709 19.3003 10.4609C20.0972 14.709 23.5487 18.8348 27.4003 19.6917C23.5487 20.5486 20.0976 24.6744 19.3003 28.9225C18.5035 24.6744 15.4839 20.8563 11.6323 19.9994Z",
    fill: "url(#paint2_linear_3375_19291)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3375_19291",
    x1: 23.9573,
    y1: 3.88544,
    x2: 16.3954,
    y2: 28.4666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132927,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392361,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7887,
    stopColor: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3375_19291",
    x1: 20.2003,
    y1: 9.90721,
    x2: 20.2003,
    y2: 29.3847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#555555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3375_19291",
    x1: 23.1732,
    y1: 4.75325,
    x2: 16.1621,
    y2: 28.1569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253989,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634371,
    stopColor: "#1C1C1C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3375_19291"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 20,
    fill: "white",
    transform: "translate(10.3003 10)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame1171277063);
export default __webpack_public_path__ + "static/media/Frame 1171277063.2553166f7a272e728abff402697df383.svg";
export { ForwardRef as ReactComponent };